export default interface BankInView {
    code: string;
    prefix: string;
    invNo: number;
    depot: string;
    divItem: string;
    section: number;
    partner: string;
    pmode: string;
    invDate: Date | string;
    invTime: Date | string;
    shipDate: Date | string;
    pterm: Date | string;
    netto: number;
    total: number;
    vat: number;
    amount: number;
    status: string;
    dpaym: boolean;
    dpaymIncl: boolean;
    dpaymNetto: number;
    dpaymVat: number;
    accGroup: string;
    currency: string;
    car: number;
    withVat: string;
    user: string;
    bankAccount: string;
    worksheet: number;
    custOrd: number;
    norder: number;
    sorder: number;
    outerInvNo: string;
    bodyNo: string;
    regNum: string;
    remark1: string;
    remark2: string;
    invCurrency: string;
    currNetto: number;
    currTotal: number;
    currVat: number;
    exchangeRate: number;
    rateDate: Date | string;
    toPayment: number;
    currToPayment: number;
    selected: boolean;
    sorted: boolean;
    statementTotal: number;

    /** Számla bruttó (a szerkesztés előtti, eredeti teljes érték) */
    grossTotal: number;
    /** Számla bruttó deviza (a szerkesztés előtti, eredeti teljes érték) */
    grossCurrTotal: number;

    sortable: boolean;
    added: boolean;
    lockAction: string;
    finalRemark: string;
}

export const bankInViewDefaultProps: BankInView = {
    code: "",
    prefix: "",
    invNo: 0,
    depot: "",
    divItem: "",
    section: 0,
    partner: "",
    pmode: "",
    invDate: "1980. 01. 01.",
    invTime: "1980. 01. 01.",
    shipDate: "1980. 01. 01.",
    pterm: "1980. 01. 01.",
    netto: 0,
    total: 0,
    vat: 0,
    amount: 0,
    status: "",
    dpaym: false,
    dpaymIncl: false,
    dpaymNetto: 0,
    dpaymVat: 0,
    accGroup: "",
    currency: "",
    car: 0,
    withVat: "",
    user: "",
    bankAccount: "",
    worksheet: 0,
    custOrd: 0,
    norder: 0,
    sorder: 0,
    outerInvNo: "",
    bodyNo: "",
    regNum: "",
    remark1: "",
    remark2: "",
    invCurrency: "",
    currNetto: 0,
    currTotal: 0,
    currVat: 0,
    exchangeRate: 0,
    rateDate: "1980. 01. 01.",
    toPayment: 0,
    currToPayment: 0,
    selected: false,
    sorted: false,
    statementTotal: 0,
    grossTotal: 0,
    grossCurrTotal: 0,

    sortable: false,
    added: false,
    lockAction: "",
    finalRemark: ""
}